const DEFAULT_GATEWAY_URL = "http://localhost:8080";

const COMMON_API_PREFIXES = ["/api/iam/", "/api/gnb/"];
const COMMON_TOP_LEVEL_PATHS = ["/csrf", "/login", "/logout"];

export function getGatewayUrl(): string {
  return (import.meta.env.VITE_API_URL || DEFAULT_GATEWAY_URL).replace(/\/+$/, "");
}

export function isAbsoluteUrl(path: string): boolean {
  return /^https?:\/\//.test(path);
}

export function isCommonGatewayPath(path: string): boolean {
  return (
    COMMON_API_PREFIXES.some((prefix) => path.startsWith(prefix)) ||
    COMMON_TOP_LEVEL_PATHS.some(
      (commonPath) => path === commonPath || path.startsWith(`${commonPath}?`)
    )
  );
}

export function getGatewayApiUrl(path: string): string {
  if (isAbsoluteUrl(path)) return path;

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const gatewayPath =
    normalizedPath.startsWith("/api/") &&
    !normalizedPath.startsWith("/api/editor/") &&
    !isCommonGatewayPath(normalizedPath)
      ? `/api/editor${normalizedPath.slice(4)}`
      : normalizedPath;

  return `${getGatewayUrl()}${gatewayPath}`;
}

export function isPublicEditorPath(pathname: string): boolean {
  return /^\/editor\/[^/]+\/?$/.test(pathname);
}

type NavigationLocation = Pick<Location, "origin" | "pathname" | "search" | "hash">;

export function sanitizeReturnTo(location: NavigationLocation): string {
  const origin = /^https?:\/\/[^/?#\r\n]+$/.test(location.origin) ? location.origin : "";
  const path = /^\/(?!\/)[^\r\n]*$/.test(location.pathname) ? location.pathname : "/";
  return `${origin}${path}${location.search}${location.hash}`;
}

export function getGatewayNavigationUrl(
  action: "login" | "logout",
  location: NavigationLocation = window.location
): string {
  const returnTo = sanitizeReturnTo(location);
  return `${getGatewayUrl()}/${action}?return_to=${encodeURIComponent(returnTo)}`;
}
